import { get, post, request } from "../request";

// 获取我的课件
// params {page_no, page_size}
export const getMyCoursewareList = (params) => get(`/v1/live/doc/list`, params);
// 获取机构课件
// params {page_no, page_size}
// export const getOrgCoursewareList = (params) =>
//   get(`/v1/seller/material/list`, {
//     page: params.page_no,
//     pageSize: params.page_size,
//     material_type: 5,
//     id: 0,
//   });
// 添加课件到房间
export const addFileToRoom = (params) => {
  return post("/v1/live/doc/addRoomDoc", params);
};
// 删除房间课件
export const deleteRoomFile = (params) => {
  return post("/v1/live/doc/delRoomDoc", params);
};
// 更新课件名称
export const updateDocName = (params) => {
  return post("/v1/live/doc/updateDocName", params);
};
